import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import { GrUserWorker } from "react-icons/gr";
import { MdOutlineMiscellaneousServices } from "react-icons/md";
import { FaHandshake } from "react-icons/fa";
import { MdLocationCity } from "react-icons/md";

const Home = () => {
  // Initialize AOS when the component mounts
  useEffect(() => {
    AOS.init({
      duration: 1000, // Set animation duration (optional)
      once: true, // Animation occurs only once (optional)
    });
  }, []);

  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: " Why is waterproofing important for my property?",
      answer:
        "Waterproofing protects your property from water damage, mold growth, structural decay, and other issues that can arise from water infiltration. It ensures the longevity of your building by preventing costly repairs in the future.",
    },
    {
      question: "How long does waterproofing last?",
      answer:
        " Waterproofing can last between 10 to 15 years if applied properly and with quality materials. Regular maintenance and inspections can extend the lifespan of your waterproofing solution.",
    },
    {
      question: "What is waterproofing?",
      answer:
        "Waterproofing is the process of making a structure or surface resistant to water penetration. This helps prevent water from causing damage to buildings, foundations, roofs, walls, and other structures.",
    },
    // Add more FAQs as needed
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="main">
      <section id="hero" className="hero section dark-background">
        <img
          src="assets/img/banner.jpeg"
          alt="Hero Background"
          data-aos="fade-in"
        />

        <div className="container">
          <div className="row">
            <div className="col-lg-10">
              <h2 data-aos="fade-up" data-aos-delay="100">
                Welcome To
                <br></br> fenice shield chemical
              </h2>
            </div>
            <div className="col-lg-5" data-aos="fade-up" data-aos-delay="300">
              <Link to="/Contact">
                <button
                  type="button"
                  className="btn btn-danger py-2"
                  style={{ backgroundColor: "#699841", border: "none" }}
                >
                  Enquiry now <i class="bi bi-arrow-right"></i>
                </button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section id="about" class="about section light-background">
        <div class="container" data-aos="fade-up" data-aos-delay="100">
          <div class="row align-items-xl-center gy-5">
            <div class="col-xl-5 content">
              {/* <h3>About Us</h3> */}
              <h2>Who we are?</h2>
              <p>
                We are a leading provider of professional waterproofing
                solutions, dedicated to protecting your home or business from
                water damage and ensuring long-lasting durability. With years of
                industry experience, we specialize in delivering high-quality
                waterproofing services for a variety of structures, including
                terraces, basements, bathrooms, swimming pools, and more. Our
                team of certified experts uses advanced techniques and premium
                materials to safeguard your property against leaks, moisture,
                and dampness.
              </p>
              <Link to="/About" class="read-more">
                <span>Read More</span>
                <i class="bi bi-arrow-right"></i>
              </Link>
            </div>

            <div class="col-xl-7">
              <div class="row gy-4 icon-boxes">
                <div class="col-md-6" data-aos="fade-up" data-aos-delay="200">
                  <div class="icon-box">
                    <i class="bi bi-buildings"></i>
                    <h5>Expertise and Experience</h5>
                    <p>
                      With years of experience in the waterproofing industry,
                      our team of specialists has the skills and knowledge to
                      handle any waterproofing challenge.
                    </p>
                  </div>
                </div>

                <div class="col-md-6" data-aos="fade-up" data-aos-delay="300">
                  <div class="icon-box">
                    <i class="bi bi-clipboard-pulse"></i>
                    <h5>High-Quality Materials</h5>
                    <p>
                      We use only the best materials available in the market,
                      ensuring durability and long-term protection.
                    </p>
                  </div>
                </div>

                <div class="col-md-6" data-aos="fade-up" data-aos-delay="400">
                  <div class="icon-box">
                    <i class="bi bi-command"></i>
                    <h5>Advanced Technology and Techniques</h5>
                    <p>
                      Our waterproofing methods are based on the latest industry
                      advancements. From liquid membranes to injection grouting,
                      we use cutting-edge techniques to deliver superior results
                      for every project.
                    </p>
                  </div>
                </div>

                <div class="col-md-6" data-aos="fade-up" data-aos-delay="500">
                  <div class="icon-box">
                    <i class="bi bi-graph-up-arrow"></i>
                    <h5>Customer Satisfaction Focused</h5>
                    <p>
                      We prioritize customer satisfaction at every step of the
                      process. From consultation to project completion, we work
                      closely with you to meet your expectations and deliver the
                      best results.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="stats-section">
        <div className="stat-item">
          <GrUserWorker className="stat-icon" />
          <h5 className="stat-number">100</h5>
          <div className="stat-title">Happy Employees</div>
        </div>

        <div className="stat-item">
          <MdOutlineMiscellaneousServices className="stat-icon" />
          <h5 className="stat-number">30</h5>
          <div className="stat-title">Our Services</div>
        </div>

        <div className="stat-item">
          <FaHandshake className="stat-icon" />
          <h5 className="stat-number">1000+</h5>
          <div className="stat-title">Happy Clients</div>
        </div>

        <div className="stat-item">
          <MdLocationCity className="stat-icon" />
          <h5 className="stat-number">6</h5>
          <div className="stat-title">Service Locations</div>
        </div>
      </div>

      <section id="features" class="features section">
        <div class="container section-title" data-aos="fade-up">
          <h2>Our Features</h2>
        </div>

        <div class="container">
          <div class="row gy-4 align-items-center features-item">
            <div
              class="col-lg-5 order-2 order-lg-1"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <h3>Experienced Team of Professionals</h3>
              <p>
                Our highly skilled team of waterproofing experts ensures that
                each project is handled with precision and care, delivering
                quality workmanship that guarantees long-lasting results.
              </p>
              <Link to="/Service" class="btn btn-get-started">
                Get Started
              </Link>
            </div>
            <div
              class="col-lg-7 order-1 order-lg-2 d-flex align-items-center"
              data-aos="zoom-out"
              data-aos-delay="100"
            >
              <div class="image-stack">
                <img
                  src="assets/img/feature-1.jpg"
                  alt=""
                  class="stack-front"
                />
                <img src="assets/img/feature-2.jpg" alt="" class="stack-back" />
              </div>
            </div>
          </div>

          <div class="row gy-4 align-items-stretch justify-content-between features-item ">
            <div
              class="col-lg-6 d-flex align-items-center features-img-bg"
              data-aos="zoom-out"
            >
              <img src="assets/img/fenice.png" class="img-fluid" alt="" />
            </div>
            <div
              class="col-lg-5 d-flex justify-content-center flex-column"
              data-aos="fade-up"
            >
              <h3>Advanced Waterproofing Techniques</h3>
              <p>
                Utilizing modern techniques such as liquid-applied membranes,
                cementitious coatings, and injection grouting, we address every
                waterproofing challenge effectively.
              </p>
              <ul>
                <li>
                  <i class="bi bi-check"></i>{" "}
                  <span>Flexible Staffing Solutions</span>
                </li>
                <li>
                  <i class="bi bi-check"></i>
                  <span> Quick Turnaround Time</span>
                </li>
              </ul>
              <Link to="/Service" class="btn btn-get-started align-self-start">
                Get Started
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section id="faq" className="faq section">
        <div className="container">
          <div className="row gy-4">
            <div className="col-lg-4" data-aos="fade-up" data-aos-delay="100">
              <div className="content px-xl-5">
                <h3>
                  <span>Frequently Asked </span>
                  <strong>Questions ?</strong>
                </h3>
              </div>
            </div>
            <div className="col-lg-8" data-aos="fade-up" data-aos-delay="200">
              <div className="faq-container">
                {faqs.map((faq, index) => (
                  <div
                    className={`faq-item ${
                      openIndex === index ? "faq-active" : ""
                    }`}
                    key={index}
                  >
                    <h3 onClick={() => toggleFAQ(index)}>
                      <span className="num">{index + 1}.</span>
                      <span>{faq.question}</span>
                    </h3>
                    <div
                      className="faq-content"
                      style={{
                        display: openIndex === index ? "block" : "none",
                      }}
                    >
                      <p>{faq.answer}</p>
                    </div>
                    <i
                      className={`faq-toggle bi ${
                        openIndex === index
                          ? "bi-chevron-down"
                          : "bi-chevron-right"
                      }`}
                    ></i>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        id="call-to-action"
        class="call-to-action section dark-background"
      >
        <img src="assets/img/cta-bg.jpg" alt="" />

        <div class="container">
          <div
            class="row justify-content-center"
            data-aos="zoom-in"
            data-aos-delay="100"
          >
            <div class="col-xl-10">
              <div class="text-center">
                <h3>Call To Action</h3>
                <p>
                  Hire Top Talent Now – Let Us Find the Right Fit for Your
                  Business!
                </p>
                <Link class="cta-btn" to="tel: +91 7904382016">
                  Call To Action
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
